import { useEffect, useState, useRef } from 'react'
import style from './Testimony.module.css'
import logo from './images/apple-touch-icon-precomposed.png'

import avatar1 from './images/image.jpg'
import avatar2 from './images/image2.jpg'
import avatar3 from './images/image3.jpg'
import avatar4 from './images/image4.jpg'

export default function(props) {

	const [sentences, setSentences] = useState(undefined)
	const [name, setName] = useState(undefined)
	const [dots, setDots] = useState(false)
	const [currentSentences, setCurrentSentences] = useState([])
	const avatars = [avatar1, avatar2, avatar3, avatar4]

	const newTestimony = (delay) => {
		const testimony = props.data[Math.floor(Math.random() * props.data.length)]
		//testimony.sentences.push('CTA')
		
		setCurrentSentences([])
		setDots(false)
		setName(undefined)

		setTimeout(() => {
			setDots(true)
			setName(testimony.Name)

			setTimeout(() => {
				setDots(false)
				setSentences(testimony.sentences)
			}, 2000)

		}, delay)
	}

	useEffect(() => {
		if (sentences) {
			nextSentence()
		}
	}, [sentences])

	const nextSentence = () => {
		if (sentences.length > 0) {
			const nextSentences = [...sentences]
			const nextSentence = nextSentences.shift()

			
			const nextCurrentStences = [...currentSentences]
			const cta = (nextSentence === 'CTA')
			nextCurrentStences.push(<Sentence key={`sentence_${nextCurrentStences.length}`} sentence={nextSentence} cta={cta} idx={nextCurrentStences.length} onRender={handleRender} />)
			setCurrentSentences(nextCurrentStences)
			
			const delay = (cta) ? 5000 : nextSentence.length * 90
			setTimeout(() => {
				setSentences(nextSentences)
			}, delay)
		} else {
			newTestimony(2000)
		}
	}

	const handleRender = (idx, height) => {
		// console.log(idx, height)
	}

	useEffect(() => {
		newTestimony(Math.floor(Math.random() * 1000))
	}, [])
	
	return (
		<div className={style.phone}>
			<div className={style.name}>{name}</div>

			{currentSentences}
			{dots && (
				<div className={style.wave}>
					<span className={style.dot}></span>
					<span className={style.dot}></span>
					<span className={style.dot}></span>
				</div>
			)}

			<div className={style.avatar}>
				<img src={avatars[Math.floor(Math.random() * 4)]}/>
			</div>
			<div className={style.time}>Now</div>
		</div>
	)	
}

function Sentence(props) {

	const ref = useRef(null)
	const [height, setHeight] = useState(0)
	const [width, setWidth] = useState(0)
	const [mode, setMode] = useState('add')

	useEffect(() => {
		const rect = ref.current.getBoundingClientRect()
		const width = rect.width
		const height = rect.height
				
		setWidth(width)
		setHeight(height)
		setMode('short')

		props.onRender(props.idx, height)

		setTimeout(() => {
			setMode('normal')
		}, 1)

		setTimeout(() => {
			setMode('in')
		}, 150)
	}, [])

	const elementStyle = {}
	if (mode === 'normal') {
		elementStyle.width = width
		elementStyle.height = height
	}
	var arabic = /[\u0600-\u06FF]/
	const classes = [style.message, style[mode], style.cta]

	if(arabic.test(props.sentence)){

		classes.push(style.arabic)
	}


	if (props.cta) {
		return (
			<div style={elementStyle} className={classes.join(' ')} ref={ref}>
				<div><img src={logo}/></div>
				<div>Show solidarity with women and girls in Afghanistan. Send them a message on social media using <strong>#YourRightsAreOurRights</strong></div>
			</div>
		)		
	}

	return (
		<div style={elementStyle} dir="auto" className={[style.message, style[mode]].join(' ')} ref={ref}>{props.sentence}</div>
	)
}